module.exports = "<iplace-section [id]=\"id\"></iplace-section>\n"